import axios from 'axios'

export default {
    getArticleCategory(){
        return axios.get('/article_category?is_active=1')
            .then(response => {
                return response.data
            })
    },
    getArticleCategoryDataSource(params){
        return axios.get('/article_category/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getArticleCategorybyID(id, params){
        return axios.get('/article_category/' + id, { params }).then(response => {
                return response.data
            })
    }, 
    createArticleCategory(formdata){
        return axios.post('/article_category', formdata)
            .then(response => {
                return response.data
            })
    },
    updateArticleCategory(id,formdata){
        return axios.post('/article_category/' + id + '/update', formdata  )
            .then(response => {
                return response.data
            })
    },
    deactivateArticleCategory(id){
        return axios.put('/article_category/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateArticleCategory(id){
        return axios.put('/article_category/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyArticleCategory(id){
        return axios.delete('/article_category/' + id)
            .then(response => {
                return response.data
            })
    },
    getArticlePositionList(){
        return axios.get('/article_category/orderlist')
            .then(response => {
                return response.data
            })
    },
    updateArticlePositionList(formdata){
        return axios.post('/article_category/updatelist', formdata)
            .then(response => {
                return response.data
            })
    },   
    updateBGImage(id,formData){
        return axios.post('/article_category/' + id + '/update_bgimage', formData)
            .then(response => {
                return response.data
            })
    },
    updateCardImage(id,formData){
        return axios.post('/article_category/' + id + '/update_cardimage', formData)
            .then(response => {
                return response.data
            })
    },
    getArticlePositionListContent(params){
        return axios.get('/article_content/orderlist', {params})
            .then(response => {
                return response.data
            })
    },
    updateArticlePositionListContent(formdata){
        return axios.post('/article_content/updatelist', formdata)
            .then(response => {
                return response.data
            })
    },
}